module.exports = __webpack_public_path__ + "static/media/Morph3.49c65c56.png";